var lastActionEvent;
['pointerdown', 'touchstart', 'mousedown', 'keydown', 'mouseover'].forEach(function (event) {
  document.addEventListener(event, function (e) {
    lastActionEvent = e;
  }, {
    capture: true,
    passive: true
  });
});
export default function () {
  return lastActionEvent;
}
;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-longtask@1.0.1@@ali/aes-tracker-plugin-longtask/es/utils/getLastAction.js
// module id = null
// module chunks = 